export default __webpack_public_path__ + "static/media/paper-clip.ed8c2116.svg";